export default __webpack_public_path__ + "static/heart-4454f89e916cc07094b837b2030135cc.png";